import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import afb104622849f4752fd696af4f3bb34d5b from "./generated-683c5b87-6a52-458e-9239-8a5a25a75e63.json";

import ac80189e9cb0dbb0a1f64c15e2ac12b63b from "./generated-9345abc9-0226-452a-bf1b-40cd2411df91.json";

import a7e168297bd7198fae5acbc36e12f383eb from "./generated-5b9d30e4-d3c1-40bf-ad05-995187121107.json";

import aed17d00a3e6d26e6c4ab140982909605b from "./generated-de8e0f43-15fd-4659-ade0-94f3cc0a165f.json";

import a6819f0f6274dca0778e8acc9298b845fb from "./generated-6ed24046-abed-4d8f-8fa3-548626bee834.json";

import ad3641639858c247446e1f2155edd75dfb from "./generated-0d9e34de-d55f-4866-94e2-39c7ef8588b9.json";

import ac14be096e483469aec8ab9f515512108b from "./generated-2d421476-ffc8-47a5-ab4b-b25a4cd77240.json";

import a1647742276ba8c44fbf717028b6e35b8b from "./generated-be81c3b9-1f85-4177-ae34-ceea6a435532.json";

import a1c836df7e598e54ec22d4168d0506e01b from "./generated-37f1d965-7b2a-481a-a80a-29da037d4df4.json";

import a194a2c96cd4744f354d946f1104ad840b from "./generated-59a3743c-4705-4a1d-ad2f-3d41e877592c.json";

import ae8c2f212a3e997aa97e3abdf64bfda80b from "./generated-bba97e00-d116-4a9d-ba89-592fc949c571.json";

import a6b14165e5b7476a0946e6845cbd58e78b from "./generated-c7f8dc75-7cab-4593-8c5b-0e2b683e9fd6.json";

import ab51985e430c1549c98e3cc9354326ac3b from "./generated-79f9d2c4-8fc9-43a8-baf8-ece3c256a5e4.json";

import a5f5967cb229cf0ada00ed3d76d4006feb from "./generated-23c866dc-a749-4507-854c-7a4750400808.json";

import a370e78a43c6be45db87df9d19a79223cb from "./generated-9b561415-2ae1-4618-888b-dc4fcbf32fc3.json";

import ae47f2112d1fb6d06d6473d9e64d30e5bb from "./generated-cfd20652-cea5-4d90-a6cd-a799c87997f6.json";

import aa15f794df70a50d73e426e36166dcca6b from "./generated-42e34960-c587-43f5-911a-fc1bc4a81257.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(afb104622849f4752fd696af4f3bb34d5b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ac80189e9cb0dbb0a1f64c15e2ac12b63b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a7e168297bd7198fae5acbc36e12f383eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aed17d00a3e6d26e6c4ab140982909605b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a6819f0f6274dca0778e8acc9298b845fb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ad3641639858c247446e1f2155edd75dfb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac14be096e483469aec8ab9f515512108b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a1647742276ba8c44fbf717028b6e35b8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a1c836df7e598e54ec22d4168d0506e01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a194a2c96cd4744f354d946f1104ad840b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ae8c2f212a3e997aa97e3abdf64bfda80b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a6b14165e5b7476a0946e6845cbd58e78b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a1c836df7e598e54ec22d4168d0506e01b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab51985e430c1549c98e3cc9354326ac3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a5f5967cb229cf0ada00ed3d76d4006feb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a1c836df7e598e54ec22d4168d0506e01b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a370e78a43c6be45db87df9d19a79223cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae47f2112d1fb6d06d6473d9e64d30e5bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(aa15f794df70a50d73e426e36166dcca6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a370e78a43c6be45db87df9d19a79223cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */